import React from 'react';
import { Button, DatePicker, Divider, Flex, Radio, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearFilter,
  saveFilter,
} from '../../../../../redux/slices/searchFiltersSlice.jsx';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';

const { RangePicker } = DatePicker;
const now = dayjs();

const SearchResultFilter = ({ onChange }) => {
  const { t } = useTranslation();
  const filter = useSelector((state) => state.searchFilter);
  const dispach = useDispatch();
  const dateFormat = 'DD.MM.YYYY';

  const handleSwitchChange = (value) => {
    dispach(saveFilter({ ...filter, precision_search: value }));
    onChange({ ...filter, precision_search: value });
  };

  const handleDateRangeChange = (value) => {
    dispach(
      saveFilter({
        ...filter,
        date_range: [value[0].format(dateFormat), value[1].format(dateFormat)],
      }),
    );
    onChange({
      ...filter,
      date_range: [value[0].format(dateFormat), value[1].format(dateFormat)],
    });
  };

  const handleOnSortByChange = (e) => {
    dispach(saveFilter({ ...filter, sortBy: e.target.value }));
    onChange({ ...filter, sortBy: e.target.value });
  };

  const handleResetFilters = () => {
    dispach(clearFilter());
    onChange({
      precision_search: false,
      date_range: null,
      sortBy: '_score-desc',
      collapsed: ['1'],
    });
  };

  return (
    <Flex
      wrap
      justify={'center'}
      align={'center'}
      gap={'small'}
      style={{ width: '100%' }}
    >
      <Switch
        defaultValue={filter.precision_search}
        onChange={handleSwitchChange}
        checkedChildren={t('Presná zhoda')}
        unCheckedChildren={t('Čiastočná zhoda')}
        style={{ width: 150 }}
        value={filter.precision_search}
      />
      <RangePicker
        format={dateFormat}
        allowEmpty={[true, true]}
        placeholder={[t('Dátum od'), t('Dátum do')]}
        value={
          filter.date_range === null
            ? null
            : [
                dayjs(filter.date_range[0], dateFormat),
                dayjs(filter.date_range[1], dateFormat),
              ]
        }
        onChange={handleDateRangeChange}
      />
      <Divider orientation="left" style={{ margin: 0 }}>
        {capitalize(t('Zoradiť podľa'))}
      </Divider>
      <Radio.Group value={filter.sortBy} onChange={handleOnSortByChange}>
        {/* For correct behavior of the filter this needs to be like thies: `<sortedParameter>-<asc/desc>` otherwise ES will not work properly*/}
        <Radio.Button value="_score-desc">
          {capitalize(t('Relevantné'))}
        </Radio.Button>
        <Radio.Button value="_score-asc">
          {capitalize(t('Najmenej relevantné'))}
        </Radio.Button>
        <Radio.Button value="created_at-desc">
          {capitalize(t('Najnovšie'))}
        </Radio.Button>
        <Radio.Button value="created_at-asc">
          {capitalize(t('Najstaršie'))}
        </Radio.Button>
      </Radio.Group>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Button type="primary" onClick={handleResetFilters}>
          {capitalize(t('Resetovať filtre'))}
        </Button>
      </div>
    </Flex>
  );
};

export default SearchResultFilter;
